// ✅ Final Updated UserDashboard.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import BackButton from "../components/BackButton";

export default function UserDashboard() {
  const navigate = useNavigate();
  const [checkingProfile, setCheckingProfile] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        navigate("/login");
        return;
      }

      try {
        // ✅ Check if artist profile already exists using UID as doc ID
        console.log('UserDashboard - Checking profile for user:', user.uid);
        const profileRef = doc(db, "artistProfiles", user.uid);
        const profileSnap = await getDoc(profileRef);
        
        console.log('UserDashboard - Profile check result:', {
          exists: profileSnap.exists(),
          data: profileSnap.exists() ? profileSnap.data() : null
        });
        
        if (profileSnap.exists()) {
          // User has a profile, redirect to Artist corner (my-art-world)
          console.log('UserDashboard - Profile exists, redirecting to Artist corner');
          navigate('/my-art-world');
        } else {
          // User needs to create a profile, show the dashboard
          console.log('UserDashboard - No profile found, showing create profile page');
          setCheckingProfile(false);
        }
      } catch (error) {
        console.error("❌ Error checking profile:", error.message);
        setCheckingProfile(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-amber-100 to-amber-200 flex flex-col justify-center items-center p-6 text-center">
      {checkingProfile && (
        <div className="fixed top-4 right-4 z-20 rounded-full border border-amber-200 bg-white/90 px-4 py-2 text-sm text-amber-700 shadow">
          Loading your creative space...
        </div>
      )}
      <BackButton className="absolute top-6 left-6" />
      
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-amber-500 mb-6">
          Welcome to Artmosphere!
        </h1>
        
        <p className="text-xl text-amber-800 max-w-2xl leading-relaxed mb-8">
          Your creative journey begins now. Let's start by creating your artist profile!
        </p>
        
        <div className="bg-white/80 backdrop-blur-sm rounded-xl p-8 shadow-xl border-2 border-amber-200 mb-6">
          <h2 className="text-2xl font-semibold text-amber-800 mb-4">
            Create Your Artist Profile
          </h2>
          <p className="text-amber-700 mb-6">
            Tell us about yourself and your artistic journey. Share your favorite styles, colors, and dreams!
          </p>
          <button
            onClick={() => navigate("/profile")}
            className="bg-gradient-to-r from-amber-500 to-amber-400 hover:from-amber-600 hover:to-amber-500 text-white px-8 py-4 rounded-full text-lg font-medium shadow-lg transition-all duration-200 transform hover:scale-105"
          >
            Start Creating My Profile
          </button>
        </div>
        
        <div className="text-sm text-amber-600">
          <p>Join thousands of young artists creating amazing art together!</p>
        </div>
      </div>
    </div>
  );
}